import * as React from 'react'

import {
  AttendanceCustomPeriodEmployeeItemFragment,
  AttendanceSidepanelCompensationBlockFragment,
} from 'generated/resources/graphql'

import CompensationOverview from 'modules/attendance/components/ClockIn/TabsBreakdown/CompensationPannel/Overview'

interface CompensationTabProps {
  employee: AttendanceCustomPeriodEmployeeItemFragment
  setSelectedCompensationBlocks: React.Dispatch<
    React.SetStateAction<AttendanceSidepanelCompensationBlockFragment[]>
  >
}

export const CompensationTab = ({
  employee,
  setSelectedCompensationBlocks,
}: CompensationTabProps) => {
  const isPartTime = !!employee.referenceContract?.partTime

  if (!employee.id) {
    return null
  }

  return (
    <CompensationOverview
      setSelectedCompensationBlocks={setSelectedCompensationBlocks}
      employeeId={employee.id}
      isPartTime={isPartTime}
    />
  )
}
